module.exports = __webpack_public_path__ + "img/avatar5.30fd84a8.png";